var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21c1.105 0 2-.906 2-2.023a2.012 2.012 0 00-2-2.023c-1.105 0-2 .906-2 2.023S10.895 21 12 21zm0-10.115c2.287 0 4.416 1.024 6.01 2.768a.464.464 0 01.054.554l-.053.07-1.935 2.116a.451.451 0 01-.668 0c-.984-1.076-2.123-1.646-3.408-1.646-1.285 0-2.424.57-3.408 1.646a.451.451 0 01-.603.058l-.065-.058-1.935-2.116a.464.464 0 010-.624c1.595-1.744 3.724-2.768 6.011-2.768zM12 5c3.703 0 7.164 1.583 9.87 4.367.145.15.17.376.07.552l-.05.072-1.851 2.16a.451.451 0 01-.668.022c-2.082-2.143-4.61-3.31-7.371-3.31s-5.288 1.167-7.371 3.31a.45.45 0 01-.605.04l-.063-.061-1.85-2.161a.464.464 0 01.02-.624C4.835 6.583 8.296 5 12 5z",
    fill: "#0C1014",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.d3c27dd8f65d3281dbe1fa6fbf24c279.svg";
export { ForwardRef as ReactComponent };